const account_center = {
    home: {
        title: '페이지를 찾을 수 없음',
        description: '이 페이지는 사용할 수 없습니다.',
    },
    page: {
        title: '계정',
        security_title: '보안',
        security_description: '계정 보안을 위해 여기에서 계정 설정을 변경하세요.',
        profile_title: '개인 정보',
        profile_description: '여기에서 개인 정보를 변경하세요.',
        sidebar_personal_info: '개인 정보',
        sidebar_security: '보안',
        sidebar_sessions: '세션',
        support: '지원',
        user_menu: '사용자 메뉴',
        sign_out: '로그아웃',
    },
    verification: {
        error_send_failed: '인증 코드를 보내지 못했습니다. 잠시 후 다시 시도해주세요.',
        error_invalid_code: '인증 코드가 잘못되었거나 만료되었습니다.',
        error_verify_failed: '인증에 실패했습니다. 코드를 다시 입력해주세요.',
        step_up_not_completed: '본인 확인이 완료되지 않았습니다. 계정에 변경 사항이 적용되지 않았습니다.',
    },
    email: {
        title: '이메일 연결',
        description: '이메일을 연결해 로그인하거나 계정 복구에 활용하세요.',
        verification_title: '이메일 인증 코드를 입력',
        verification_description: '인증 코드가 이메일 {{email_address}}(으)로 전송되었습니다.',
        success: '기본 이메일이 연결되었습니다.',
    },
    phone: {
        title: '전화번호 연결',
        description: '로그인하거나 계정 복구에 사용할 전화번호를 연결하세요.',
        verification_title: 'SMS 인증 코드를 입력',
        verification_description: '인증 코드가 전화번호 {{phone_number}}(으)로 전송되었습니다.',
        success: '기본 전화번호가 연결되었습니다.',
    },
    username: {
        title: '사용자 이름 설정',
        description: '사용자 이름은 문자, 숫자, 밑줄(_)만 사용할 수 있습니다.',
        policy_description: '{{requirements}}',
        success: '사용자 이름이 성공적으로 업데이트되었습니다.',
    },
    security: {
        add: '추가',
        change: '변경',
        remove: '삭제',
        not_set: '설정되지 않음',
        social_sign_in: '소셜 로그인',
        social_not_linked: '연결되지 않음',
        email_phone: '이메일 / 전화번호',
        email: '이메일',
        phone: '전화번호',
        password: '비밀번호',
        configured: '설정됨',
        not_configured: '설정되지 않음',
        two_step_verification: '2단계 인증',
        authenticator_app: '인증 앱',
        passkeys: '패스키',
        backup_codes: '백업 코드',
        email_verification_code: '이메일 인증 코드',
        phone_verification_code: '전화 인증 코드',
        passkeys_count_one: '{{count}}개의 패스키',
        passkeys_count_other: '{{count}}개의 패스키',
        backup_codes_count_one: '{{count}}개의 코드',
        backup_codes_count_other: '{{count}}개의 코드',
        view: '보기',
        manage: '관리',
        turn_on_2_step_verification_description: '추가 보안 계층을 추가합니다. 로그인 시 두 번째 인증 단계가 요청됩니다.',
        two_step_verification_incomplete_description: '2단계 인증이 켜져 있지만 아직 적용되지 않았습니다.',
        two_step_verification_off_description: '2단계 인증 환경설정이 꺼져 있습니다. 보안 정책에 따라 추가 인증이 필요할 수 있습니다.',
        turn_off_2_step_verification: '2단계 인증 끄기',
        turn_off_2_step_verification_description: '2단계 인증을 비활성화하면 로그인 시 추가 보호 계층이 제거됩니다. 계속하시겠습니까?',
        disable_2_step_verification: '비활성화',
        no_verification_method_warning: '설정이 완료되지 않았습니다. 아래에서 인증 방법을 추가하여 2단계 인증 설정을 완료하세요.',
        two_step_verification_load_failed: '2단계 인증 설정을 불러오지 못했습니다. 다시 시도하세요.',
        two_step_verification_retry: '다시 시도',
        passkey_sign_in_prompt: '패스키 설정 안내 표시',
        passkey_sign_in_prompt_description: '켜면 더 빠르고 안전한 로그인을 위해 패스키를 설정하라는 안내를 받게 됩니다.',
        account_removal: '계정 삭제',
        delete_your_account: '내 계정 삭제',
        delete_account: '계정 삭제',
        remove_username_confirmation_title: '사용자 이름 제거',
        remove_username_confirmation_description: '제거하면 이 사용자 이름으로 더 이상 로그인할 수 없습니다. 계속하시겠습니까?',
        remove_email_confirmation_title: '이메일 주소 제거',
        remove_email_confirmation_description: '제거하면 이 이메일 주소로 더 이상 로그인할 수 없습니다. 계속하시겠습니까?',
        remove_phone_confirmation_title: '전화번호 제거',
        remove_phone_confirmation_description: '제거하면 이 전화번호로 더 이상 로그인할 수 없습니다. 계속하시겠습니까?',
        email_removed: '이메일 주소가 성공적으로 제거되었습니다.',
        phone_removed: '전화번호가 성공적으로 제거되었습니다.',
        username_removed: '사용자 이름이 성공적으로 제거되었습니다.',
        trusted_devices: {
            title: 'MFA 신뢰할 수 있는 기기',
            current_device: '현재 기기',
            expires_on: '{{date}}에 만료',
            unknown_location: '알 수 없는 위치',
            remove: '제거',
            removed: '신뢰할 수 있는 기기를 제거했습니다.',
            loading: '로딩 중...',
            empty: '신뢰할 수 있는 기기가 없습니다.',
            load_failed: '신뢰할 수 있는 기기를 불러오지 못했습니다. 다시 시도해 주세요.',
            retry: '다시 시도',
            remove_confirmation_title: '신뢰할 수 있는 기기를 제거할까요?',
            remove_confirmation_description: '다음에 이 기기에서 로그인할 때 MFA를 다시 완료해야 합니다. 현재 세션은 계속 활성 상태로 유지됩니다.',
        },
        personal_access_tokens: {
            title: '개인용 액세스 토큰',
            description: '개인 액세스 토큰을 사용하여 사용자를 대신해 API에 인증할 수 있습니다. 로그아웃하거나 비밀번호를 변경하더라도 만료되거나 폐기할 때까지 활성 상태로 유지됩니다.',
            create: '새 토큰 만들기',
            created_at: '{{date}}에 생성됨',
            expires_on: '{{date}}에 만료',
            expired_on: '{{date}}에 만료됨',
            expired: '만료됨',
            never_expires: '만료되지 않음',
            never_expires_warning: '이 토큰에는 만료일이 없습니다. 보안을 강화하려면 만료일이 있는 새 토큰을 만들고 이 토큰을 폐기하세요.',
            rename: '이름 변경',
            revoke: '폐기',
            loading: '로딩 중...',
            empty: '개인용 액세스 토큰이 없습니다.',
            load_failed: '개인용 액세스 토큰을 불러오지 못했습니다. 다시 시도해 주세요.',
            retry: '다시 시도',
            create_modal_title: '개인용 액세스 토큰 만들기',
            create_modal_description: '토큰을 식별할 수 있는 이름을 지정하고 만료 기간을 선택하세요.',
            token_name: '토큰 이름',
            token_name_placeholder: '내 토큰',
            expiration: '만료 기간',
            expiration_days: '{{count}}일',
            created_modal_title: '개인용 액세스 토큰이 생성되었습니다',
            show_once_warning: '이 토큰은 다시 확인할 수 없습니다. 지금 복사하여 안전한 곳에 보관하세요.',
            copied: '개인용 액세스 토큰이 복사되었습니다.',
            rename_modal_title: '개인용 액세스 토큰 이름 변경',
            rename_modal_description: '이 개인용 액세스 토큰의 새 이름을 입력하세요.',
            renamed: '개인용 액세스 토큰 이름이 변경되었습니다.',
            revoke_confirmation_title: '개인용 액세스 토큰을 폐기하시겠습니까?',
            revoke_confirmation_description: '"{{name}}"을(를) 사용하는 모든 애플리케이션이나 스크립트가 즉시 액세스 권한을 잃게 됩니다. 계속하시겠습니까?',
            revoked: '개인용 액세스 토큰이 폐기되었습니다.',
        },
    },
    social: {
        linked: '{{connector}}이(가) 성공적으로 연결되었습니다.',
        not_enabled: '이 소셜 로그인 방법은 활성화되어 있지 않습니다. 도움이 필요하면 관리자에게 문의하세요.',
        removed: '{{connector}}이(가) 성공적으로 제거되었습니다.',
        remove_confirmation_title: '소셜 계정 제거',
        remove_confirmation_description: '{{connector}}을(를) 제거하면 다시 추가하기 전까지 해당 계정으로 로그인하지 못할 수 있습니다.',
    },
    password: {
        title: '비밀번호 설정',
        description: '계정을 안전하게 보호할 새 비밀번호를 만들어 주세요.',
        success: '비밀번호가 성공적으로 업데이트되었습니다.',
    },
    code_verification: {
        send: '인증 코드 보내기',
        resend: '아직 받지 못하셨나요? <a>인증 코드 다시 보내기</a>',
        resend_countdown: '아직 받지 못하셨나요? {{seconds}}초 후에 다시 보낼 수 있습니다',
    },
    email_verification: {
        email_label: '이메일 주소',
    },
    phone_verification: {
        phone_label: '전화번호',
    },
    mfa: {
        totp_already_added: '이미 인증 앱을 추가했습니다. 먼저 기존 앱을 제거하십시오.',
        totp_not_enabled: '인증 앱 OTP가 활성화되지 않았습니다. 관리자에게 도움을 요청하세요.',
        backup_code_already_added: '이미 활성 백업 코드가 있습니다. 새 코드를 생성하기 전에 사용하거나 제거하십시오.',
        backup_code_not_enabled: '백업 코드가 활성화되지 않았습니다. 관리자에게 도움을 요청하세요.',
        backup_code_requires_other_mfa: '백업 코드를 사용하려면 다른 MFA 방법을 먼저 설정해야 합니다.',
        passkey_not_enabled: '패스키가 활성화되지 않았습니다. 관리자에게 도움을 요청하세요.',
        passkey_already_registered: '이 패스키는 이미 계정에 등록되어 있습니다. 다른 인증기를 사용해 주세요.',
    },
    update_success: {
        default: {
            title: '업데이트되었습니다!',
            description: '귀하의 정보가 업데이트되었습니다.',
        },
        email: {
            title: '이메일 업데이트됨!',
            description: '이메일 주소가 성공적으로 업데이트되었습니다.',
        },
        phone: {
            title: '전화번호 업데이트됨!',
            description: '전화번호가 성공적으로 업데이트되었습니다.',
        },
        username: {
            title: '사용자 이름 변경됨!',
            description: '사용자 이름이 성공적으로 업데이트되었습니다.',
        },
        password: {
            title: '비밀번호 변경됨!',
            description: '비밀번호가 성공적으로 업데이트되었습니다.',
        },
        totp: {
            title: '인증 앱 추가됨!',
            description: '인증 앱이 계정에 성공적으로 연결되었습니다.',
        },
        totp_replaced: {
            title: '인증 앱이 교체되었습니다!',
            description: '인증 앱이 성공적으로 교체되었습니다.',
        },
        backup_code: {
            title: '백업 코드가 생성되었습니다!',
            description: '백업 코드가 저장되었습니다. 안전한 곳에 보관하십시오.',
        },
        passkey: {
            title: '패스키가 추가되었습니다!',
            description: '패스키가 계정에 성공적으로 연결되었습니다.',
        },
        social: {
            title: '소셜 계정 연결됨!',
            description: '소셜 계정이 성공적으로 연결되었습니다.',
        },
    },
    backup_code: {
        title: '백업 코드',
        description: '2단계 인증에 문제가 있는 경우 이 백업 코드 중 하나를 사용하여 계정에 액세스할 수 있습니다. 각 코드는 한 번만 사용할 수 있습니다.',
        copy_hint: '복사하여 안전한 곳에 보관하세요.',
        generate_new_title: '새 백업 코드 생성',
        generate_new: '새 백업 코드 생성',
    },
    passkey: {
        title: '패스키',
        added: '추가됨: {{date}}',
        last_used: '마지막 사용: {{date}}',
        never_used: '사용 안 함',
        unnamed: '이름 없는 패스키',
        renamed: '패스키 이름이 변경되었습니다.',
        deleted: '패스키가 삭제되었습니다.',
        add_another_title: '다른 패스키 추가',
        add_another_description: '기기 생체 인증, 보안 키(예: YubiKey) 또는 기타 사용 가능한 방법을 사용하여 패스키를 등록하세요.',
        add_passkey: '패스키 추가',
        delete_confirmation_title: '패스키 삭제',
        delete_confirmation_description: '이 패스키를 삭제하면 더 이상 인증에 사용할 수 없습니다.',
        rename_passkey: '패스키 이름 변경',
        rename_description: '이 패스키의 새 이름을 입력하세요.',
        name_this_passkey: '이 기기 패스키 이름 지정',
        name_passkey_description: '2단계 인증을 위해 이 기기가 성공적으로 확인되었습니다. 여러 키가 있는 경우 식별할 수 있도록 이름을 사용자 지정하세요.',
        name_input_label: '이름',
    },
    sessions: {
        page_title: '세션',
        page_description: '활성 세션과 승인된 서드파티 애플리케이션을 관리합니다.',
        title: '세션',
        current_session: '현재 세션',
        signed_in_at: '{{date}}에 로그인',
        revoke_session: '로그아웃',
        revoke_session_title: '세션 로그아웃',
        revoke_session_description: '이 세션에서 로그아웃하고 관련된 모든 액세스를 철회합니다. 계속하시겠습니까?',
        no_other_sessions: '다른 활성 세션이 없습니다.',
        loading: '로딩 중...',
        third_party_apps_title: '서드파티 앱',
        no_third_party_apps: '승인된 서드파티 애플리케이션이 없습니다.',
        third_party_apps_load_failed: '서드파티 앱을 불러오지 못했습니다. 다시 시도해 주세요.',
        granted_at: '{{date}}에 승인',
        dynamic_app: '다이나믹 앱',
        client_id: '클라이언트 ID: {{clientId}}',
        revoke_grant: '제거',
        revoke_grant_title: '서드파티 앱 액세스 제거',
        revoke_grant_description: '이 애플리케이션에 부여된 액세스를 철회합니다. 이미 발급된 액세스 토큰은 만료될 때까지 유효할 수 있습니다. 계속하시겠습니까?',
        revoke_grant_failed: '일부 권한 철회에 실패했습니다. 다시 시도해 주세요.',
    },
};
export default Object.freeze(account_center);
